var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1463 7.70654H11.2935V11.5593H15.1463V7.70654Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 11.5591H15.1472V15.4119H19V11.5591Z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8528 15.413V11.5593V7.70649V3.8528H11.2935H15.1472V0H11.2935H3.8528H0V3.8528V7.70649V11.5593V15.413V19.2658H3.8528H11.2935H15.1472V15.413H11.2935H3.8528Z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 3.85254H15.1472V7.70534H19V3.85254Z",
    fill: "#000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconBlack);
export default __webpack_public_path__ + "static/media/logo-icon-black.52a4e970bfc0e0a2270ce9f396bec8ce.svg";
export { ForwardRef as ReactComponent };